import PermissionsManager from './PermissionsManager';

export default PermissionsManager;
